import { create } from "zustand"
import moment from "moment"
import {FilterFormTypes, InvoiceAdjustmentList, PaginationData} from "../types/invoiceAdjustmentTypes"
import { PaginationState } from "types"

interface InvoiceAdjustmentState {
    filter: FilterFormTypes
    pagination_data: PaginationData
    data: InvoiceAdjustmentList[]
    isLoading: boolean
    error: string | null

    // Actions
    setFilter: (filter: Partial<FilterFormTypes>) => void
    setPaginationData: (pagination_data: PaginationState | ((prev: PaginationState) => PaginationState)) => void
    setData: (data: InvoiceAdjustmentList[]) => void
    setIsLoading: (value: boolean) => void
    resetFilter: () => void
}

export const invoiceListStore = create<InvoiceAdjustmentState>((set, get) => ({
    // 🧩 Initial state
    filter: {
        DateEnd: moment().endOf("month").format("YYYY-MM-DD"),
        DateFrom: moment().startOf("month").format("YYYY-MM-DD"),
        invoice_status:'4',
    },

    pagination_data:{
        total: 0,
        page: 1,
        pages: 1,
        limit: 10,
        keyword: '',
        size:10
    },

    data: [],
    isLoading: false,
    error: null,

    // 🧩 Actions
    setFilter: (filter) =>
        set((state) => ({
            filter: { ...state.filter, ...filter },
        })),


    setPaginationData: (pagination_data) =>
        set((state) => ({
            pagination_data: typeof pagination_data === 'function' 
                ? pagination_data(state.pagination_data) 
                : { ...state.pagination_data, ...pagination_data },
        })),

    setData: (data) => set({ data }),
    setIsLoading: (value) => set({ isLoading: value }),

    resetFilter: () =>
        set({
            filter: {
                DateEnd: moment().endOf("month").format("YYYY-MM-DD"),
                DateFrom: moment().startOf("year").format("YYYY-MM-DD"),
                invoice_status: '4',
                page:1,
                limit:10
            },
        }),
}))